import React from 'react';
import { Button, Form } from 'react-bootstrap';
import { FaChevronLeft, FaChevronRight, FaCalendarDay } from 'react-icons/fa';
import { getMonthName, getPreviousMonth, getNextMonth, getCurrentMonthYear, getYearRange } from '../../../utils/calendarUtils';
import './Calendar.css';

const MonthNavigator = ({ month, year, onMonthChange }) => {
  const handlePrevious = () => {
    const prev = getPreviousMonth(month, year);
    onMonthChange(prev.month, prev.year);
  };

  const handleNext = () => {
    const next = getNextMonth(month, year);
    onMonthChange(next.month, next.year);
  };

  const handleToday = () => {
    const current = getCurrentMonthYear();
    onMonthChange(current.month, current.year);
  };

  const handleMonthSelect = (e) => {
    onMonthChange(parseInt(e.target.value), year);
  };

  const handleYearSelect = (e) => {
    onMonthChange(month, parseInt(e.target.value));
  };

  const months = Array.from({ length: 12 }, (_, i) => i + 1);
  const years = getYearRange(new Date().getFullYear());

  return (
    <div className="month-navigator">
      <div className="nav-controls">
        <Button 
          variant="outline-primary" 
          size="sm" 
          onClick={handlePrevious}
          aria-label="Previous month"
        >
          <FaChevronLeft />
        </Button>

        <div className="month-year-display">
          <Form.Select 
            value={month} 
            onChange={handleMonthSelect}
            className="month-select"
            size="sm"
          >
            {months.map(m => (
              <option key={m} value={m}>{getMonthName(m)}</option>
            ))}
          </Form.Select>

          <Form.Select 
            value={year} 
            onChange={handleYearSelect}
            className="year-select"
            size="sm"
          >
            {years.map(y => (
              <option key={y} value={y}>{y}</option>
            ))}
          </Form.Select>
        </div>

        <Button 
          variant="outline-primary" 
          size="sm" 
          onClick={handleNext}
          aria-label="Next month"
        >
          <FaChevronRight />
        </Button>

        <Button 
          variant="primary" 
          size="sm" 
          onClick={handleToday}
          className="today-btn"
        >
          <FaCalendarDay /> Today
        </Button>
      </div>
    </div>
  );
};

export default MonthNavigator;
